import React, {useEffect} from "react";
import {Box, FormLabel, Grid, makeStyles, Typography} from "@material-ui/core";

import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import CustomSelect from "../../../components/CustomSelect/CustomSelect";
import CustomCalendar from "../../../components/CustomCalendar/MuiPicker";
import PersonalInfoIcon from "../../../assets/img/personal-info.svg";
import StarIcon from "../../../assets/img/star.svg";
import {genderValues} from "../../../constants/selectOptions";
import {greyDark, whiteGrey} from "../../../constants/colors";
import CustomCheckbox from "../../../experiments/CustomCheckbox";
import Collapse from '@material-ui/core/Collapse';
import {useFormContext} from "react-hook-form";
import NestedFrequentFlyersForm from "./NestedFrequentFlyersForm";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  form: {
    marginBottom: "50px",
    flexDirection: "column",
    display: "none",
    [down("xs")]: {
      marginBottom: 0,
    },
  },
  activeForm: {
    display: "flex",
    [down("sm")]: {
      marginBottom: 0,
      background: whiteGrey,
      padding: "35px 19px",
      borderRadius: "10px",
    },
  },
  additionalInfo: {
    background: whiteGrey,
    padding: "10px 0px",
    borderRadius: 10,
    marginBottom: 10
  },
  heading: {
    fontFamily: "sbcBold",
    fontSize: "14px",
    lineHeight: 1.2,
    fontWeight: "bold",
  },
  helper: {
    color: greyDark
  },

}));

const Forms = ({ field, activeFormIndex, currentValues, extras, airlines, selectedFlight, index }) => {
  const { form, activeForm, additionalInfo, helper } = useStyles();
  const { watch, clearErrors } = useFormContext();

  const formValues = watch(`passengers[${index}]`);

  useEffect(() => {
    clearErrors(`passengers[${index}.frequentFlyer]`)
  }, [clearErrors, currentValues.frequentFlyerCheck, index])

  useEffect(() => {
    clearErrors(`passengers[${index}.globalEntryNumber]`)
  }, [clearErrors, currentValues.globalEntryNumberCheck, index])

  useEffect(() => {
    clearErrors(`passengers[${index}.knownTravelerNumber]`)
  }, [clearErrors, currentValues.knownTravelerNumberCheck, index])

  useEffect(() => {
    clearErrors(`passengers[${index}.tsaPrecheckNumber]`)
  }, [clearErrors, currentValues.tsaPrecheckNumberCheck, index])

  return (
    <>
      <div
        key={index}
        className={`${form} ${activeFormIndex === index && activeForm}`}
      >
        <Box mb={4}>
          <Box
            mb={3}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Box ml={2} mr={2}>
              <img src={PersonalInfoIcon} alt="personal-info" />
            </Box>
            <Typography variant="h2">Personal Info</Typography>
          </Box>
          <Grid container spacing={1} justify="center">
            <Grid item xs={12} sm={6}>
              <CustomTextField
                label="First Name"
                defaultValue={currentValues.firstName}
                name={`passengers[${index}].firstName`}
              />
              <CustomTextField
                label="Middle Name"
                defaultValue={currentValues.middleName}
                name={`passengers[${index}].middleName`}
              />
              <CustomTextField
                label="Last Name"
                defaultValue={currentValues.lastName}
                name={`passengers[${index}].lastName`}
              />
              <CustomSelect
                name={`passengers[${index}].gender`}
                options={genderValues.options}
                label={genderValues.label}
                defaultValue={currentValues.gender}
                location="gender"
              />
              <CustomCalendar
                label="Date of birth: MM/DD/YYYY"
                name={`passengers[${index}].birthDate`}
                defaultValue={currentValues.birthDate}
              />
            </Grid>
          </Grid>
        </Box>
        {!!extras.length && (
          <Box>
            <Box
              mb={3}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Box ml={2} mr={2}>
                <img src={StarIcon} alt="extras-info" />
              </Box>
              <Typography variant="h2">Extras</Typography>
            </Box>
            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} sm={6}>
                {extras?.map((extra, idx) => (
                  <CustomSelect
                    name={`passengers[${index}].${extra?.fieldName}`}
                    options={extra.options}
                    label={extra.label}
                    defaultValue={currentValues[extra?.fieldName]}
                    key={idx}
                  />
                ))}
              </Grid>
            </Grid>
          </Box>
        )}
        {!selectedFlight?.hasAward ? (
          <Box>
            <Box mb={3} mt={2.4} display="flex" alignItems={'center'} justifyContent={'center'}>
              <Grid container spacing={1} justifyContent="center">
                <Grid item xs={12} sm={6}>
                  <Box className={additionalInfo}>
                    <Typography align="center" className="heading">
                      Additional options
                    </Typography>
                  </Box>

                  <Box
                    alignItems={'center'}
                    spacing={2}
                  >
                    {!!selectedFlight.available_airlines && (
                      <>
                        <FormLabel>
                          <CustomCheckbox name={`passengers[${index}].frequentFlyerCheck`} label="Frequent Flyer Number"
                            value={currentValues.frequentFlyerCheck} />
                        </FormLabel>
                        <Box>
                          <Collapse in={formValues.frequentFlyerCheck}>
                            <Box mt={1} ml={1.5}>
                              <NestedFrequentFlyersForm airlines={airlines} selectedFlight={selectedFlight}
                                nestIndex={index} />
                            </Box>
                          </Collapse>
                        </Box>
                      </>
                    )}

                    <FormLabel>
                      <CustomCheckbox name={`passengers[${index}].knownTravelerNumberCheck`} label="Known Traveler" value={currentValues.knownTravelerNumberCheck} />
                    </FormLabel>
                    <Box>
                      <Collapse in={formValues.knownTravelerNumberCheck}>
                        <Box mt={1} ml={1.5}>
                          <CustomTextField
                            label="Known Traveler Number"
                            defaultValue={currentValues.knownTravelerNumber}
                            name={`passengers[${index}].knownTravelerNumber`}
                          />
                        </Box>
                      </Collapse>
                    </Box>
                    <FormLabel>
                      <CustomCheckbox name={`passengers[${index}].globalEntryNumberCheck`} label="Global Entry" value={currentValues.globalEntryNumber} />
                    </FormLabel>
                    <Box>
                      <Collapse in={formValues.globalEntryNumberCheck}>
                        <Box mt={1} ml={1.5}>
                          <CustomTextField
                            label="Global Entry Number"
                            defaultValue={currentValues.globalEntryNumber}
                            name={`passengers[${index}].globalEntryNumber`}
                          />
                        </Box>
                      </Collapse>
                    </Box>
                    <FormLabel>
                      <CustomCheckbox name={`passengers[${index}].tsaPrecheckNumberCheck`} label="TSA Precheck" value={currentValues.tsaPrecheckNumber} />
                    </FormLabel>
                    <Box>
                      <Collapse in={formValues.tsaPrecheckNumberCheck}>
                        <Box mt={1} ml={1.5}>
                          <CustomTextField
                            label="TSA Precheck Number"
                            defaultValue={currentValues.tsaPrecheckNumber}
                            name={`passengers[${index}].tsaPrecheckNumber`}
                          />
                        </Box>
                      </Collapse>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        ) : null}
      </div>
    </>
  );
};

export default Forms;
